import { useState } from 'react';
import { faqs } from '@/mocks/photography';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm">你可能想了解的一些问题</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-lg overflow-hidden bg-background-50"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h4 className="text-sm font-medium text-foreground-950 pr-4">{faq.question}</h4>
                <i
                  className={`flex-shrink-0 text-foreground-500 transition-transform duration-300 text-lg ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}